import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Login from "./component";

import { loginUserAsAdminAndAuthenticate } from "./actions";
import { isAdminUser } from "../processor/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginUserAndAuthenticateConnect: loginUserAsAdminAndAuthenticate,
      isAdminUserConnect: isAdminUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
